import {ModuleWithProviders, NgModule} from '@angular/core';

import {DragulaModule} from 'ng2-dragula';
import {NGXS_PLUGINS, NgxsModule} from '@ngxs/store';
import {clearStatePlugin} from './ngxs/plugins/clear-state.plugin';
import {InfraDirectivesModule} from './directives/infra.directives.module';
import {InfraPipesModule} from './pipes/infra.pipes.module';
import {InfraComponentsModule} from './components/infra-components.module';
import {PrototypesService} from './utils/prototypes.service';
import {NgxsStoragePluginModule, StorageOption} from '@ngxs/storage-plugin';
import {AcListState} from './components/ac-list/ac-list.state';
import {AcTableState} from './components/ac-table/state/ac-table.state';
import {environment} from './environments/environment';
import {AcTableDataState} from './components/ac-table/state/ac-table-data/ac-table-data.state';
import {SchemaHelperService} from './services/schema-helper.service';

@NgModule({
    imports: [
        InfraDirectivesModule,
        InfraPipesModule,
        InfraComponentsModule,
    ],
    exports: [InfraDirectivesModule, InfraPipesModule, InfraComponentsModule],
})
export class InfraModule {
    static forRoot(): ModuleWithProviders<InfraModule> {
        return {
            ngModule: ExtendedInfraModule,
            providers: [
                PrototypesService,
                SchemaHelperService,
                {
                    provide: NGXS_PLUGINS,
                    useValue: clearStatePlugin,
                    multi: true
                }
            ]
        };
    }
}

export const NgxsModuleForRoot = NgxsModule.forRoot([AcTableState, AcTableDataState, AcListState], {developmentMode: !environment.production});
export const NgxsStoragePluginModuleForRoot = NgxsStoragePluginModule.forRoot({key: ['tableState'], storage: StorageOption.SessionStorage});
export const DragulaModuleForRoot = DragulaModule.forRoot();


@NgModule({
    imports: [
        NgxsModuleForRoot,
        NgxsStoragePluginModuleForRoot,
        DragulaModuleForRoot,
        InfraModule
    ],
    exports: [InfraModule],
})
export class ExtendedInfraModule {}
